



















































































import { $store } from "@/store";
import { Vue, Component, Prop, Model } from "vue-property-decorator";
import VueDraggableResizable from "vue-draggable-resizable";
import { LayoutInsert } from "@/store/layout/types";
import { throttle } from "../../utils/throttle";

@Component({
  components: {
    VueDraggableResizable,
  },
})
export default class PdfPageLayoutInsert extends Vue {
  @Prop({ default: 0 })
  idx!: number;

  @Prop({ default: 1 })
  scale!: number;

  @Model()
  insert!: LayoutInsert;

  get width() {
    return this.insert.width * this.scale;
  }

  get active() {
    return this.idx == $store.wizard.selectedInsert;
  }

  get height() {
    return this.insert.height * this.scale;
  }

  get lux() {
    return this.insert.llx * this.scale;
  }

  get hideInsertDetails() {
    return $store.appearance.hideInsertDetails;
  }

  get hideLayoutToolbar() {
    return $store.appearance.hideLayoutToolbar;
  }

  toggleInsertDetails() {
    $store.appearance.hideInsertDetails = !$store.appearance.hideInsertDetails;
    $store.appearance.hideLayoutToolbar = !$store.appearance.hideLayoutToolbar;
  }

  get canMoveToPreviousPage() {
    return this.insert.page > 1;
  }

  moveToPreviousPage() {
    if (this.canMoveToPreviousPage) {
      $store.layouts.updateInsert(this.idx, { page: this.insert.page - 1 });
      this.navigateToInsert(this.insert.page - 1);
    }
  }

  get canMoveToNextPage() {
    const total = $store.layoutSources.layoutSource?.metadata
      .numberOfPages as number;
    return this.insert.page < total;
  }

  moveToNextPage() {
    if (this.canMoveToNextPage) {
      $store.layouts.updateInsert(this.idx, { page: this.insert.page + 1 });
      this.navigateToInsert(this.insert.page + 1);
    }
  }

  navigateToInsert(page: number) {
    if (this.scrollElem) {
      this.scrollElem.scrollTop = 0;
      $store.wizard.layoutPage = page;
      setTimeout(() => {
        document
          .getElementById((this.insert as LayoutInsert).ref)
          ?.scrollIntoView();
      }, 100);
    }
  }

  get luy() {
    return (
      (this.pageMetadata.height - this.insert.lly) * this.scale - this.height
    );
  }

  get containerWidth() {
    return $store.appearance.currentWidth;
  }

  get pageMetadata() {
    return $store.layoutSources.getPageMetadata(this.insert.page);
  }

  get scrollElem() {
    return document.getElementById("pdfviewer-container");
  }

  throttledResize = throttle((width, height, scale, idx) => {
    $store.layouts.updateInsert(idx, {
      width: Math.round(width / scale),
      height: Math.round(height / scale),
    });
  }, 30)[0];

  onActivated() {
    $store.wizard.selectedInsert = this.idx;
  }

  onDeactivated() {
    $store.wizard.selectedInsert = null;
  }

  onResize(x: number, y: number, width: number, height: number) {
    this.throttledResize(width, height, this.scale, this.idx);
  }

  onDrag(lux: number, luy: number) {
    $store.layouts.updateInsert(this.idx, {
      llx: Math.round(lux / this.scale),
      lly: Math.round(this.invertYAxis((luy + this.height) / this.scale)),
    });
  }

  invertYAxis(luy: number) {
    return this.pageMetadata.height - luy;
  }
}
